import {
  HomeIcon,
  UsersIcon,
  DocumentTextIcon,
  ExclamationTriangleIcon,
  HeartIcon,
  ShieldExclamationIcon,
  CheckBadgeIcon,
  BriefcaseIcon,
  UserGroupIcon,
  ClockIcon,
  HandRaisedIcon,
  AcademicCapIcon,
  MapIcon,
  CurrencyDollarIcon,
  NoSymbolIcon,
  SpeakerWaveIcon,
  QuestionMarkCircleIcon,
  CreditCardIcon,
  ChartBarIcon,
  BuildingOfficeIcon,
  DocumentMagnifyingGlassIcon,
  BanknotesIcon,
  DocumentDuplicateIcon,
  BookOpenIcon,
  ScaleIcon,
} from "@heroicons/react/24/outline"


export const adminModules = [
    {
        name: "Dashboard",
        href: "/dashboard",
        icon: HomeIcon,
        // current: currentPath === "/dashboard",
        roles: ["admin", "barangay_official"],
        description: "Data Overview",
    },
    {
        name: "Ayuda",
        href: "/ayuda",
        icon: BanknotesIcon,
        // current: currentPath.startsWith("/ayuda"),
        roles: ["admin", "barangay_official", "national_official"],
        description: "Government Assistance",
    },
    {
        name: "Residents",
        href: "/residents",
        icon: UsersIcon,
        // current: currentPath.startsWith("/residents"),
        roles: ["admin", "barangay_official"],
        description: "Digital Barangay ID System",
    },
    {
        name: "Documents",
        href: "/documents",
        icon: DocumentTextIcon,
        // current: currentPath.startsWith("/documents"),
        roles: ["admin", "barangay_official"],
        description: "Issuance & Tracking",
    },
    {
        name: "Disputes",
        href: "/disputes",
        icon: ScaleIcon,
        // current: currentPath.startsWith("/disputes"),
        roles: ["admin", "barangay_official"],
        description: "Barangay Justice System",
    },
    {
        name: "Complaints",
        href: "/complaints",
        icon: ExclamationTriangleIcon,
        // current: currentPath.startsWith("/complaints"),
        roles: ["admin", "barangay_official"],
        description: "Incident Management",
    },
    // {
    //   name: 'Health Records',
    //   href: '/health',
    //   icon: HeartIcon,
    //   current: currentPath.startsWith('/health'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Social Services Monitoring'
    // },
    // {
    //   name: 'Emergency',
    //   href: '/emergency',
    //   icon: ShieldExclamationIcon,
    //   current: currentPath.startsWith('/emergency'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Crisis Response'
    // },
    {
        name: "Voters",
        href: "/voters",
        icon: CheckBadgeIcon,
        // current: currentPath.startsWith("/voters"),
        roles: ["admin", "barangay_official"],
        description: "Precinct Locator",
    },
    {
        name: "Business Permits",
        href: "/business",
        icon: BriefcaseIcon,
        // current: currentPath.startsWith("/business"),
        roles: ["admin", "barangay_official"],
        description: "Monitoring & Endorsement",
    },
    // {
    //   name: 'Youth Records',
    //   href: '/youth',
    //   icon: UserGroupIcon,
    //   current: currentPath.startsWith('/youth'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'SK Engagement'
    // },
    // {
    //   name: 'Curfew Violations',
    //   href: '/curfew',
    //   icon: ClockIcon,
    //   current: currentPath.startsWith('/curfew'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Youth Offense Logging'
    // },
    {
        name: "Community Services",
        href: "/community",
        icon: HandRaisedIcon,
        // current: currentPath.startsWith("/community"),
        roles: ["admin", "barangay_official"],
        description: "Scheduling & Monitoring",
    },
    // {
    //   name: 'Livelihood Programs',
    //   href: '/livelihood',
    //   icon: AcademicCapIcon,
    //   current: currentPath.startsWith('/livelihood'),
    //   roles: ['admin', 'barangay_official', 'resident'],
    //   description: 'Training Registration'
    // },
    // {
    //   name: 'Vulnerability Mapping',
    //   href: '/vulnerability',
    //   icon: MapIcon,
    //   current: currentPath.startsWith('/vulnerability'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Household Assessment'
    // },
    // {
    //   name: 'Pet Registration',
    //   href: '/pets',
    //   icon: HeartIcon,
    //   current: currentPath.startsWith('/pets'),
    //   roles: ['admin', 'barangay_official', 'resident'],
    //   description: 'Rabies Control'
    // },
    // {
    //   name: 'Environmental Projects',
    //   href: '/environment',
    //   icon: AcademicCapIcon,
    //   current: currentPath.startsWith('/environment'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Tree Planting Log'
    // },
    // {
    //   name: 'Budget Allocation',
    //   href: '/budget',
    //   icon: CurrencyDollarIcon,
    //   current: currentPath.startsWith('/budget'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Transparency'
    // },
    // {
    //   name: 'Anti-Drug Campaign',
    //   href: '/antidrug',
    //   icon: NoSymbolIcon,
    //   current: currentPath.startsWith('/antidrug'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Surrenderee Monitoring'
    // },
    // {
    //   name: 'Public Forums',
    //   href: '/forums',
    //   icon: SpeakerWaveIcon,
    //   current: currentPath.startsWith('/forums'),
    //   roles: ['admin', 'barangay_official', 'resident'],
    //   description: 'Assembly Attendance'
    // },
    // {
    //   name: 'Surveys',
    //   href: '/surveys',
    //   icon: QuestionMarkCircleIcon,
    //   current: currentPath.startsWith('/surveys'),
    //   roles: ['admin', 'barangay_official', 'resident'],
    //   description: 'Feedback System'
    // },
    // {
    //   name: 'Payments',
    //   href: '/payments',
    //   icon: CreditCardIcon,
    //   current: currentPath.startsWith('/payments'),
    //   roles: ['admin', 'barangay_official', 'resident'],
    //   description: 'Online Portal'
    // },
    // {
    //   name: 'Analytics',
    //   href: '/analytics',
    //   icon: ChartBarIcon,
    //   current: currentPath.startsWith('/analytics'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'LGU Reporting'
    // },
    {
        name: "Institutions",
        href: "/institutions",
        icon: BuildingOfficeIcon,
        // current: currentPath.startsWith("/institutions"),
        roles: ["admin", "barangay_official"],
        description: "BBI Management",
    },
    {
        name: "Legislation",
        href: "/legislation",
        icon: DocumentMagnifyingGlassIcon,
        // current: currentPath.startsWith("/legislation"),
        roles: ["admin", "barangay_official"],
        description: "Resolution Tracker",
    },
    // {
    //   name: 'Expenditures',
    //   href: '/expenditures',
    //   icon: BanknotesIcon,
    //   current: currentPath.startsWith('/expenditures'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Budget Monitoring'
    // },
    // {
    //   name: 'Forms Repository',
    //   href: '/forms',
    //   icon: DocumentDuplicateIcon,
    //   current: currentPath.startsWith('/forms'),
    //   roles: ['admin', 'barangay_official', 'resident'],
    //   description: 'Template Repository'
    // },
    // {
    //   name: 'Training',
    //   href: '/training',
    //   icon: BookOpenIcon,
    //   current: currentPath.startsWith('/training'),
    //   roles: ['admin', 'barangay_official'],
    //   description: 'Capacity Building'
    // },
]
